












































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/asdcom/BaseComponent';
import { ButtonList } from "sweetalert/typings/modules/options/buttons";
import { MailItemDto, MailItemLogDto } from '@/asdcom/apiproxy/apiproxy.dto';
import { IHeader } from '@/store/models/staff/IHeader';
import moment from "moment";

@Component({})
export default class ApplicantMailComponent extends BaseComponent {
  loading: boolean = false;
  mailModel = new MailItemDto();
  headers: IHeader[] = [
    { text: "Date", value: "creationTime", align: "center" },
    { text: "Log Entry", value: "mailItemActionEnum", align: "center" },
  ]

  @Prop({default: () => {}})
   viewModel: MailItemDto;
  @Prop({default: () => []})
   logList: MailItemLogDto[];

  created() {
    this.getMailDetails();
  }

  formatCreatedDate() {
    let fancyDate = moment(this.mailModel.creationTime).format("ll");
    return fancyDate;
  }

  @Watch("viewModel")
  async getMailDetails() {
    this.mailModel = this.viewModel;
    // const ret = await this.$appsvs.staffVpBox.retrieveMailItemDocumentPreview(this.viewModel.id);
    // this.previewImage = `data:image/jpeg;base64,${ret}`;
    
  }

  downloadPdf() {
    this.$appsvs.common.downloadPdfFile(this.mailModel.documentBinaryObjectId as string);
  }

 
}
